export enum Role {
  admin = 'admin',
  user = 'user',
  editor = 'editor',
}
